/**
 * dun-custom.js
 * JavaScript personalizado de dun (takedun.cl) para el tema Shapes 4.3.1
 *
 * POR QUÉ EXISTE ESTE ARCHIVO:
 * Los bundles de Shapes (*.bundle.js, global.bundle.js, etc.) se sobrescriben
 * en cada actualización del tema. Este archivo NO existe en Shapes original,
 * por lo que sobrevive cualquier update sin perder customizaciones.
 *
 * REGLA DE ORO:
 * Todo JS nuevo específico de dun va aquí. NUNCA en archivos de Shapes.
 * Hookearse a eventos del tema vía document.addEventListener('theme:...').
 * Usar funciones de utils.js (fetchJSON, formatMoney, debounce, etc.) directamente.
 *
 * Última actualización: 2026-05-06
 * Autor: cuore-group <cuoregroupspa@gmail.com>
 */

(function () {
  'use strict';

  // NOTA: theme-events.js (línea 115 de theme.liquid) usa async defer.
  // Si necesitas escuchar eventos theme:* desde aquí, envuelve el listener
  // en document.addEventListener('DOMContentLoaded', ...) para garantizar
  // que theme-events.js ya esté cargado.

  // === Tracking y analytics ===


  // === Customizaciones PDP ===


  // === Customizaciones Cart ===

  // El ícono del carrito del header lleva a la página /cart, PERO el drawer
  // lateral se conserva para cuando se agrega un producto (ModalCart escucha
  // "shapes:cart:afteradditem"). Con cart_type=modal el botón del header abre
  // el drawer via Alpine (@click open('cart')); capturamos el click ANTES que
  // Alpine, detenemos su handler y navegamos a /cart.
  document.addEventListener(
    'click',
    function (e) {
      var btn = e.target.closest('#CartButton');
      if (!btn) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      window.location.href = root.replace(/\/$/, '') + '/cart';
    },
    true // fase de captura: corre antes del listener de Alpine (burbujeo)
  );


  // === Carrito lateral: footer custom (dun-cart-footer) ===
  // El footer del drawer (dun-cart-footer) NO se ata a la lógica de morphing de
  // Shapes (a propósito, para no perder las customizaciones). Por eso el
  // subtotal y la línea de descuentos se refrescan acá con fetch('/cart.js') en
  // cada evento de carrito. Los botones/íconos son estáticos y persisten solos.
  function dunFormatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      var fmt = (window.Shopify && window.Shopify.money_format) || '${{amount}}';
      return window.Shopify.formatMoney(cents, fmt);
    }
    var value = (cents / 100).toLocaleString('es-CL', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });
    return '$' + value;
  }

  function dunRefreshCartFooter() {
    var footer = document.querySelector('[data-dun-cart-footer]');
    if (!footer) return;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        // Ocultar el footer si el carrito quedó vacío.
        if (cart.item_count === 0) {
          footer.hidden = true;
          return;
        }
        footer.hidden = false;

        var sub = footer.querySelector('[data-dun-cf-subtotal]');
        if (sub) sub.textContent = dunFormatMoney(cart.total_price);

        // OJO: /cart.js (AJAX) expone `total_discount` (singular); `total_discounts`
        // solo existe en Liquid. Con el nombre equivocado siempre daba 0.
        var discount = cart.total_discount || 0;
        var drow = footer.querySelector('[data-dun-cf-discount]');
        var dval = footer.querySelector('[data-dun-cf-discount-value]');
        if (drow && dval) {
          if (discount > 0) {
            drow.hidden = false;
            dval.textContent = '−' + dunFormatMoney(discount);
          } else {
            drow.hidden = true;
          }
        }
      })
      .catch(function () {});
  }

  ['shapes:cart:afteradditem', 'shapes:cart:cartqtychange', 'shapes:cart:update'].forEach(
    function (ev) {
      window.addEventListener(ev, dunRefreshCartFooter);
    }
  );

  // === Carrito lateral: nota "Déjanos tus comentarios" colapsable ===
  // El label es click-to-expand (el textarea arranca oculto vía CSS). Se togglea
  // el display inline del textarea directamente (el inline gana sobre el CSS sin
  // depender de la estructura del DOM), + una clase en el wrap para el ícono +/−.
  // IMPORTANTE: se escucha en FASE DE CAPTURA (true) porque el panel del drawer
  // (#right-drawer-slot) tiene @click.stop de Alpine, que corta el burbujeo antes
  // de llegar a document. La captura corre antes de ese stopPropagation.
  document.addEventListener(
    'click',
    function (e) {
      var label = e.target.closest('label[for="CartSpecialInstructions"]');
      if (!label) return;
      e.preventDefault();
      var ta = document.getElementById('CartSpecialInstructions');
      if (!ta) return;
      var isOpen = ta.style.display === 'block';
      ta.style.display = isOpen ? 'none' : 'block';
      if (!isOpen) ta.focus();
      if (label.parentElement) {
        label.parentElement.classList.toggle('dun-note-open', !isOpen);
      }
    },
    true // fase de captura: corre antes del @click.stop del panel del drawer
  );


  // === Helpers ===

})();
